<template>
  <div id="app-view-catalog" class="container is-widescreen">
    <catalogViewer :catalogId="$route.params.id"></catalogViewer>
  </div>
</template>




<script>

import viewer from "@/components/viewer"
import catalogViewer from "@/components/catalogViewer"
  //{{$route.params.id}}
  //props:['id'],
export default {
  name: "catalog",
  components: { viewer, catalogViewer },
  
  data () {
    return {
      catalogId: 1      
    }
  }, 
  
  methods:{
    viewExample(){

    },
    viewContents(){

    },
    loadCatalog(){
      console.log('load catalog');
    }
  },

  created(){
      
  },

  mounted(){
   //if (this.$route.params.id) {   this.catalogId = 1  } else { this.catalogId = parseInt(this.$route.params.id)    };
   //catalogViewer.loadCatalog
  }

}

</script>
